export const BASE_URL = 'https://backoffice.aca.am';
export const SPREADSHEET_URL = 'https://docs.google.com/spreadsheets/d';
